<jw-modal id="transportJobCreationModal">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <h1 class='header'>Add job</h1>

  <div class="form-row">
    <div class="form-group col-md-4">
      <label for="inputEmail4">Qty ({{ this.getUnitForJob()  }})</label>
      <input type="number" [(ngModel)]='this.job.qty' [class.is-invalid]='this.job.qty <= 0' name='name' class="form-control" id="inputEmail4">
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-4">
      <label for="inputEmail4">Time</label>
      <input type="time" [(ngModel)]='this.job.time' [class.is-invalid]='!this.job.time' name='name' class="form-control" id="inputEmail4">
    </div>
  </div>

  <button class='btn btn-success' [disabled]='this.isSaving' (click)='this.save()'>Save</button>&nbsp;
  <!-- <button class='btn btn-danger' (click)='this.cancel()'>Cancel</button> -->
</jw-modal>
